




























































import Vue, { PropType } from 'vue'
import { Video, VideoChannel } from '../../../PeerTube/shared/models'

export default Vue.extend({
  props: {
    channel: Object as PropType<VideoChannel>
  },

  computed: {
    host () {
      const url = this.channel.url

      return new URL(url as string).host
    },

    discoverChannelMessage () {
      return this.$gettextInterpolate(this.$gettext('Discover this channel on %{host}'), { host: this.host })
    }
  }
})
